<template>
  <v-container fluid>
    <v-row>
      <v-col class="pt-0" cols="3">
        <v-text-field
          v-model="search"
          label="ค้นหา"
          prepend-icon="mdi-magnify"
          clearable
        ></v-text-field>
      </v-col>
      <v-col>
        <v-btn color="primary" :to="{ name: 'AccessTokenAdd' }">
          <v-icon small left>mdi-plus</v-icon>เพิ่ม
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      :sort-by="['id']"
      :sort-desc="[true]"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :custom-filter="filterValue"
      :headers="headers"
      :items="accessTokens"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
    >
      <template v-slot:item.created="{ item }">
        {{ item.created | date }}
      </template>
      <template v-slot:item.expired="{ item }">
        {{ item.expired | date }}
      </template>
      <template v-slot:item.app="{ item }">
        <span v-if="item.app">{{ item.app }}</span>
        <span v-else>-</span>
      </template>
      <template v-slot:item.permission="{ item }">
        <span v-if="item.permission">{{ item.permission }}</span>
        <span v-else-if="!item.app">-</span>
        <span v-else>
          <v-btn small color="primary" @click="assignToken(item)"
            >กำหนดสิทธิ์
          </v-btn>
        </span>
      </template>
      <template v-slot:item.revoke="{ item }">
        <span v-if="!item.app">-</span>
        <span v-else-if="item.revoke === false">
          <v-btn small color="error" @click="revokeItem(item)"
            >ยกเลิกสิทธิ์
          </v-btn>
        </span>
        <span v-else class="error--text">ยกเลิกสิทธิ์แล้ว</span>
      </template>
    </v-data-table>
    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="loadingConfirmDialog"
      :dialogContent="dialogContent"
      @cancelConfirmDialog="cancelConfirmDialog"
      @submitConfirmDialog="submitConfirmDialog"
    />
  </v-container>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      confirmDialog: false,
      loadingConfirmDialog: false,
      dialogContent: {
        title: 'title',
        text: 'text',
        value: 'value',
      },
      loading: true,
      search: '',
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Name',
          align: 'start',
          value: 'name_th',
        },
        { text: 'Created', value: 'created' },
        { text: 'Expired', value: 'expired' },
        { text: 'Permission', value: 'permission' },
        { text: 'App', value: 'app' },
        { text: 'Revoke', value: 'revoke' },
      ]
    },
    accessTokens() {
      return this.$store.state.accessToken.accessTokens
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'สิทธิ์ความปลอดภัย',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchAccessTokens: 'accessToken/fetchAccessTokens',
      revokeToken: 'accessToken/revokeToken',
    }),
    filterValue(value, search, item) {
      return (
        item.name_th.toLowerCase().includes(search.toLowerCase()) ||
        moment(item.created)
          .format('YYYY-MM-DD, HH:mm:ss')
          .toLowerCase()
          .includes(this.search.toLowerCase()) ||
        moment(item.expired)
          .format('YYYY-MM-DD, HH:mm:ss')
          .toLowerCase()
          .includes(this.search.toLowerCase()) ||
        item.app.toLowerCase().includes(search.toLowerCase())
      )
    },
    assignToken(item) {
      const id = item.id
      this.$router.push({ name: 'AccessTokenAssign', params: { id } })
    },
    revokeItem(item) {
      this.confirmDialog = true
      this.dialogContent = {
        title: 'ยืนยันการยกเลิกสิทธิ์ความปลอดภัย',
        text: 'คุณต้องการยกเลิกสิทธิ์ความปลอดภัย',
        value: item.name_th,
        item: item,
      }
    },
    cancelConfirmDialog() {
      this.confirmDialog = false
    },
    submitConfirmDialog(item) {
      this.loadingConfirmDialog = true
      item.revoke = true
      this.revokeToken(item)
        .then(() => {
          this.loadingConfirmDialog = false
          this.confirmDialog = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ยกเลิกสิทธิ์สำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)
        })
        .catch((error) => {
          this.loadingConfirmDialog = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    loadData() {
      this.fetchAccessTokens()
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
  },
}
</script>
